import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Popover from '@material-ui/core/Popover';

import Link from '../../Link';
import { useStyles } from './styles';

const AlgorithmPopover = ({ label }) => {
	const { t } = useTranslation();
	const classes = useStyles();

	return (
		<PopupState variant="popover" popupId="demo-popup-popover">
			{popupState => (
				<Fragment>
					<Link
						tabIndex={0}
						variant="subtitle1"
						style={{ fontWeight: 700, color: '#2A78B8' }}
						{...bindTrigger(popupState)}>
						{label}
					</Link>

					<Popover
						{...bindPopover(popupState)}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'right'
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'center'
						}}
						classes={{ paper: classes.popoverPaper }}>
						<Box p={2}>
							<Typography variant="body2">{t('pages.home.categories.algorithmDescription')}</Typography>
						</Box>
					</Popover>
				</Fragment>
			)}
		</PopupState>
	);
};

AlgorithmPopover.propTypes = {
	label: PropTypes.string.isRequired
};

export default AlgorithmPopover;
